import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TableColumn } from '../../models/table-column';
import { OperationFilterOptionModel } from '../../models/operation/operation-filter-option.model';
import {
  getOperationFilterOptions,
  getTableColumns,
} from './operation-table-columns';

export interface OperationListState {
  columns: TableColumn[];
  lastPage: boolean;
  filterOptions: OperationFilterOptionModel;
  filterValue: string;
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'operation-list' })
export class OperationListStore extends Store<OperationListState> {
  constructor() {
    super({
      columns: getTableColumns(),
      filterOptions: getOperationFilterOptions(),
      filterValue: '',
    });
  }
}
